module.exports = __webpack_public_path__ + "static/media/24.12aa6f68.mp3";